import React, { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate, useLocation } from "react-router-dom";
import { clearJwtFromLocalStorage } from "../../services/auth";

const Logout = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const logoutAndRedirect = () => {
      sessionStorage.clear();
      clearJwtFromLocalStorage(); // Clear JWT from localStorage on logout
      setTimeout(() => {
        const searchParams = new URLSearchParams(location.search);
        const redirectUrl = searchParams.get("redirectUrl");
        if (redirectUrl) {
          navigate(redirectUrl);
        } else {
          navigate("/login");
        }
      }, 1000);
    };
    logoutAndRedirect();
  }, [instance, navigate, location]);

  const handleLogBackIn = () => {
    const searchParams = new URLSearchParams(location.search);
    const redirectUrl = searchParams.get("redirectUrl");
    if (redirectUrl) {
      navigate(redirectUrl);
    } else {
      navigate("/login");
    }
  };

  return (
    <div className="card-glass min-w-[450px] max-w-lg w-full space-y-8 p-10 rounded-xl shadow-lg">
      <div>
        <img className="mx-auto h-12 w-auto" src="logo.svg" alt="Lumeris" />
        <h2 className="mt-6 text-center text-3xl font-sol-w01 text-stretch-wide text-white">
          Logged Out
        </h2>
        <p className="mt-2 text-center text-sm text-gray-300">
          Please visit again soon!
        </p>
      </div>
      <div>
        <button
          onClick={handleLogBackIn}
          className="group relative w-4/5 left-1/2 translate -translate-x-1/2 flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-105"
        >
          Log Back In
        </button>
      </div>
    </div>
  );
};

export default Logout;
